import { useDispatch, useSelector } from 'react-redux';
import { Store } from 'components/common/types/Store.types';
import Input from 'lib/Input';
import { IconSize, InputShape, InputSize, InputTheme } from 'components/common/types/Input.types';
import editSvg from 'assets/icons/edit.svg';
import { changeNewProductName } from 'store/productManagement/reducer';
import { useState } from 'react';
import Auth from 'modules/Auth';
import { getIsReadOnly } from 'store/productManagement/selectors';

const PLACEHOLDER_PRODUCT_NAME = 'New product';

export const CreateProductHeader: React.FC = () => {
  const dispatch = useDispatch();
  const name = useSelector((state: Store) => state.productManagement.newProduct.name);
  const { userName } = Auth.getData();
  const isReadOnly = useSelector(getIsReadOnly);

  const [productName, setProductName] = useState('');

  const onBlur = (): void => {
    const currentDateAndTime = new Date();
    const year = currentDateAndTime.getFullYear();
    const month = currentDateAndTime.getMonth() + 1;
    const date = currentDateAndTime.getDate();
    const time = `${currentDateAndTime.getHours()}${currentDateAndTime.getMinutes()}`;

    const defaultProductName = `${year}${month}${date}${time}_Product by ${userName}`;

    dispatch(changeNewProductName(productName.length ? productName : defaultProductName));
  };

  return (
    <div className="-ml-2" data-test-id="create-product-header">
      <Input
        autoFocus={!isReadOnly}
        onBlur={onBlur}
        value={name}
        dataTestId="product-name-input"
        theme={InputTheme.ITALIC_WHITE}
        placeholder={PLACEHOLDER_PRODUCT_NAME}
        onChange={(value: string) => setProductName(value)}
        endIconSvg={!isReadOnly ? editSvg : undefined}
        iconSize={IconSize.EXTRA_SMALL}
        size={InputSize.EXTRA_SMALL}
        shape={InputShape.ROUNDED_MEDIUM}
        className="py-1"
        name="Product name"
        isDisabled={isReadOnly}
      />
    </div>
  );
};
